var inputs = document.querySelectorAll('form input');
inputs.forEach(function(input) {
    var label = document.createElement('label');
    var text = input.name[0].toUpperCase() + input.name.slice(1);
    label.classList.add('field-label');
    label.htmlFor = input.id;
    label.textContent = text;
    input.placeholder = text;
    input.parentElement.prepend(label);
});

//# sourceMappingURL=js_task_fix_form_DOM.671e23a5.js.map
